const AdPlacements = {
    REWARDED_VIDEO: '183911338963055_218075575546631',
    INTERSTITIAL: '183911338963055_218079468879575',
}

export default AdPlacements;